// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coach-apply-container {
  background: url("https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=1600&q=80")
    no-repeat center center/cover;
  min-height: 100vh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "IBM Plex Sans", sans-serif;
}

.coach-apply-content {
  background-color: rgba(255, 255, 255, 0.98);
  padding: 2rem;
  border-radius: 16px;
  max-width: 850px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ace-logo {
  max-width: 120px;
  margin-bottom: 1rem;
}

.apply-heading {
  font-size: 2rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 2rem;
}

.form-container {
  width: 100%;
  min-height: 1500px;
  position: relative;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .coach-apply-content {
    padding: 1.5rem;
  }

  .apply-heading {
    font-size: 1.5rem;
  }

  .ace-logo {
    max-width: 90px;
  }

  .form-container {
    min-height: 1600px;
  }
}

@media (max-width: 480px) {
  .coach-apply-container {
    padding: 1rem;
  }

  .form-container {
    min-height: 1700px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CoachApply.css"],"names":[],"mappings":"AAAA;EACE;iCAC+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".coach-apply-container {\n  background: url(\"https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=1600&q=80\")\n    no-repeat center center/cover;\n  min-height: 100vh;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: \"IBM Plex Sans\", sans-serif;\n}\n\n.coach-apply-content {\n  background-color: rgba(255, 255, 255, 0.98);\n  padding: 2rem;\n  border-radius: 16px;\n  max-width: 850px;\n  width: 100%;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.ace-logo {\n  max-width: 120px;\n  margin-bottom: 1rem;\n}\n\n.apply-heading {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #222;\n  margin-bottom: 2rem;\n}\n\n.form-container {\n  width: 100%;\n  min-height: 1500px;\n  position: relative;\n}\n\niframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 8px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .coach-apply-content {\n    padding: 1.5rem;\n  }\n\n  .apply-heading {\n    font-size: 1.5rem;\n  }\n\n  .ace-logo {\n    max-width: 90px;\n  }\n\n  .form-container {\n    min-height: 1600px;\n  }\n}\n\n@media (max-width: 480px) {\n  .coach-apply-container {\n    padding: 1rem;\n  }\n\n  .form-container {\n    min-height: 1700px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
